"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../utils");

var _constants = require("./constants");

var _interactiveChip = require("./interactive-chip");

var _propTypes = require("./propTypes");

var _staticChip = require("./static-chip");

var _core = require("@emotion/core");

var _excluded = ["avatar", "backgroundColor", "badge", "children", "colorScheme", "dismissButtonAltText", "dismissButtonRef", "icon", "iconPosition", "id", "isSelected", "onClick", "onDismiss", "onKeyDown", "size"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ChipWithoutDocs = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var avatar = _ref.avatar,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? _constants.chipDefaultProps.backgroundColor : _ref$backgroundColor,
      badge = _ref.badge,
      children = _ref.children,
      _ref$colorScheme = _ref.colorScheme,
      colorScheme = _ref$colorScheme === void 0 ? _constants.chipDefaultProps.colorScheme : _ref$colorScheme,
      dismissButtonAltText = _ref.dismissButtonAltText,
      dismissButtonRef = _ref.dismissButtonRef,
      icon = _ref.icon,
      _ref$iconPosition = _ref.iconPosition,
      iconPosition = _ref$iconPosition === void 0 ? _constants.chipDefaultProps.iconPosition : _ref$iconPosition,
      id = _ref.id,
      isSelected = _ref.isSelected,
      onClick = _ref.onClick,
      onDismiss = _ref.onDismiss,
      onKeyDown = _ref.onKeyDown,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? _constants.chipDefaultProps.size : _ref$size,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var isInteractive = typeof onClick === 'function' && !avatar;

  var chipBaseProps = _objectSpread({
    backgroundColor: backgroundColor,
    children: children,
    colorScheme: colorScheme,
    icon: icon,
    iconPosition: iconPosition,
    id: id,
    size: size
  }, forwardedProps);

  var interactiveChipProps = _objectSpread(_objectSpread({}, chipBaseProps), {}, {
    badge: badge,
    isSelected: isSelected,
    onClick: onClick,
    onKeyDown: onKeyDown
  });

  var staticChipProps = _objectSpread(_objectSpread({}, chipBaseProps), {}, {
    avatar: avatar,
    dismissButtonAltText: dismissButtonAltText,
    dismissButtonRef: dismissButtonRef,
    onDismiss: onDismiss
  });

  return isInteractive ? (0, _core.jsx)(_interactiveChip.InteractiveChip, (0, _extends2.default)({}, interactiveChipProps, {
    ref: ref
  })) : (0, _core.jsx)(_staticChip.StaticChip, (0, _extends2.default)({}, staticChipProps, {
    ref: ref
  }));
});
var ChipWithDocs = (0, _stencilReactDesc.describe)(ChipWithoutDocs).description('Compact element that represent an input, attribute, or action');
ChipWithDocs.defaultProps = _objectSpread({}, _constants.chipDefaultProps);
ChipWithDocs.propTypes = _objectSpread({}, _propTypes.chipPropTypes);
var Chip = (0, _utils.withTestAttributes)({
  component: 'StencilChip'
})(ChipWithDocs);
Chip.displayName = 'Chip';
var _default = Chip;
exports.default = _default;